
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL3 } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";
import { toast } from "react-toastify";

const RouteSupervisorStore = create((set, get) => ({
    routeSupervisorData: [],
    loading: false,
    error: false,
    statusFilter: "",

    fetchRouteSupervisorData: async (queryParams) => {
        set({ loading: true, error: null });
        try {
            const routeSupervisorData = await apiCall({
                url: `${API_BASE_URL3}MasterCreate/GetAllRouteSupervisors`,
                method: "get",
                token: localStorage.getItem("token"),
            });

            set({
                routeSupervisorData: Array.isArray(routeSupervisorData) ? routeSupervisorData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");

            // Handle 404 (No Data Found) by setting an empty array
            if (error.response && error.response.status === 404) {
                set({
                    routeSupervisorData: [],
                    error: "No hygiene observations found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },

    addRouteSupervisorData: async (newRouteSupervisorData) => {
        set({ loading: true, error: null });
        try {
            const response = await axios.post(
                `${API_BASE_URL3}MasterCreate/AddRouteSupervisor`,
                newRouteSupervisorData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            set((state) => ({
                routeSupervisorData: [...state.routeSupervisorData, response],
                loading: false
            }));
            toast.success(response.data);
            return { success: true };

        } catch (error) {
            console.error("Error adding observation:", error.response?.data || error.message);

            if (error.response?.status === 400) { // Handle validation errors
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add Route Supervisor";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },

    updateRouteSupervisorData: async (existingRouteSupervisorData) => {
        set({ loading: true, error: null });
        try {
            const response = await axios.put(
                `${API_BASE_URL3}MasterCreate/UpdateRouteSupervisor`,
                existingRouteSupervisorData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            set((state) => ({
                routeSupervisorData: [...state.routeSupervisorData, response],
                loading: false
            }));
            console.log(response)

            toast.success(response.data);
            return { success: true };

        } catch (error) {
            console.error("Error adding observation:", error.response?.data || error.message);

            if (error.response?.status === 400) { // Handle validation errors
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add Route Supervisor";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },

}));

export default RouteSupervisorStore;
